import "./App.css";
import React from "react";
import { ToastContainer } from "react-toastify";
import Form from "./components/Form";

function App() {
  return (
    <div>
      <ToastContainer />
      <Form />
    </div>
  );
}

export default App;
